export default __webpack_public_path__ + "static/media/project-bg-ssm.6217aee1.svg";